const userState = {
  firstNameUser: null,
  lastNameUser: null,
};
const user = (state = userState, action) => {
  let newState = state;
  switch (action.type) {
  }
  return newState;
};
export default user;
